import { Directive } from '@angular/core';
import {
  CdkCell,
  CdkCellDef,
  CdkFooterCell,
  CdkFooterCellDef,
  CdkHeaderCell,
  CdkHeaderCellDef,
} from '@angular/cdk/table';

@Directive({
  selector: '[appCellDef]',
  providers: [{ provide: CdkCellDef, useExisting: AppCellDefDirective }],
})
export class AppCellDefDirective extends CdkCellDef {}

@Directive({
  selector: '[appHeaderCellDef]',
  providers: [
    { provide: CdkHeaderCellDef, useExisting: AppHeaderCellDefDirective },
  ],
})
export class AppHeaderCellDefDirective extends CdkHeaderCellDef {}

@Directive({
  selector: '[appFooterCellDef]',
  providers: [
    { provide: CdkFooterCellDef, useExisting: AppFooterCellDefDirective },
  ],
})
export class AppFooterCellDefDirective extends CdkFooterCellDef {}

@Directive({
  // Kebab-case attribute selector mirrors the CDK convention
  // (`cdk-header-cell, th[cdk-header-cell]`) so consumer templates can
  // keep `<th app-header-cell>` instead of switching to `[appHeaderCell]`.
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'app-header-cell, th[app-header-cell]',
  host: {
    class: 'app-header-cell',
    role: 'columnheader',
  },
})
export class AppHeaderCellDirective extends CdkHeaderCell {}

// `role` is set dynamically by `CdkFooterCell` based on the table's role
// (`gridcell` when role=grid/treegrid, otherwise `cell`).
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'app-footer-cell, td[app-footer-cell]',
  host: { class: 'app-footer-cell' },
})
export class AppFooterCellDirective extends CdkFooterCell {}

// `role` is set dynamically by `CdkCell` based on the table's role
// (`gridcell` when role=grid/treegrid, otherwise `cell`).
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'app-cell, td[app-cell]',
  host: { class: 'app-cell' },
})
export class AppCellDirective extends CdkCell {}
